/**
 * Week utilities for Sunday-Saturday week logic
 */

export const getCurrentWeek = () => {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 = Sunday, 6 = Saturday
  
  // Calculate Sunday of current week
  // If today is Sunday (0), subtract 0 days
  // If today is Monday (1), subtract 1 day
  // etc.
  const sunday = new Date(today);
  sunday.setDate(today.getDate() - dayOfWeek);
  sunday.setHours(0, 0, 0, 0);
  
  // Calculate Saturday (6 days after Sunday)
  const saturday = new Date(sunday);
  saturday.setDate(sunday.getDate() + 6);
  saturday.setHours(23, 59, 59, 999);
  
  return {
    start: formatDate(sunday),
    end: formatDate(saturday)
  };
};

export const getPreviousWeek = (weekStart) => {
  const sunday = new Date(weekStart + 'T00:00:00');
  sunday.setDate(sunday.getDate() - 7);
  
  const saturday = new Date(sunday);
  saturday.setDate(sunday.getDate() + 6);
  
  return {
    start: formatDate(sunday),
    end: formatDate(saturday)
  };
};

export const getNextWeek = (weekStart) => {
  const sunday = new Date(weekStart + 'T00:00:00');
  sunday.setDate(sunday.getDate() + 7);
  
  const saturday = new Date(sunday);
  saturday.setDate(sunday.getDate() + 6);
  
  return {
    start: formatDate(sunday),
    end: formatDate(saturday)
  };
};

export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatDateDisplay = (dateStr) => {
  const date = new Date(dateStr + 'T00:00:00');
  return date.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric',
    year: 'numeric'
  });
};

export const formatDayWithDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr + 'T00:00:00');
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${month}/${day}`;
};

export const isCurrentWeek = (weekStart) => {
  const current = getCurrentWeek();
  return current.start === weekStart;
};

export const calculateTotals = (activities) => {
  const totals = {
    leadsWorked: 0,
    doorKnocks: 0,
    phoneCalls: 0,
    presentations: 0,
    sales: 0,
    futureAppointments: 0,
    annualizedPremium: 0,
    referralsReceived: 0,
    referralsContacted: 0
  };
  
  activities.forEach(day => {
    if (!day.offDay) {
      totals.leadsWorked += parseInt(day.leadsWorked) || 0;
      totals.doorKnocks += parseInt(day.doorKnocks) || 0;
      totals.phoneCalls += parseInt(day.phoneCalls) || 0;
      totals.presentations += parseInt(day.presentations) || 0;
      totals.sales += parseInt(day.sales) || 0;
      totals.futureAppointments += parseInt(day.futureAppointments) || 0;
      totals.annualizedPremium += parseFloat(day.annualizedPremium) || 0;
      totals.referralsReceived += parseInt(day.referralsReceived) || 0;
      totals.referralsContacted += parseInt(day.referralsContacted) || 0;
    }
  });
  
  return totals;
};
